import {
  Cherry, Citrus, Apple, Grape, Banana, Leaf, Sprout, Flame,
  Coffee, Wheat, Cookie, Nut, Candy, Droplet, Snowflake, Heart,
  Sparkles, Wine, Martini, GlassWater, Zap, Flower2, Moon, Sun,
  IceCream, IceCream2, Milk, Egg, Soup, Bean, Carrot, Salad,
} from "lucide-react";

// Map ingredient names to lucide icons (best-effort, used only as visual flourish)
const iconMap = {
  // Fruits
  "Strawberry": Cherry, "Raspberry": Cherry, "Blueberry": Cherry, "Blackberry": Cherry,
  "Cherry": Cherry, "Peach": Apple, "Apricot": Apple, "Mango": Apple,
  "Pineapple": Sprout, "Banana": Banana, "Apple": Apple, "Pear": Apple,
  "Lemon": Citrus, "Lime": Citrus, "Orange": Citrus, "Blood Orange": Citrus,
  "Grapefruit": Citrus, "Passion Fruit": Sprout, "Coconut": Nut, "Watermelon": Apple,
  "Cantaloupe": Apple, "Fig": Apple, "Grape": Grape, "Kiwi": Sprout,
  "Papaya": Sprout, "Guava": Sprout, "Lychee": Sprout, "Pomegranate": Apple,
  "Plum": Apple, "Date": Sprout, "Dragon Fruit": Flower2, "Persimmon": Apple,
  "Cranberry": Cherry, "Acai": Cherry, "Yuzu": Citrus,
  // Creams
  "Hazelnut": Nut, "Pistachio": Nut, "Almond": Nut, "Vanilla": Flower2,
  "Fior di Latte": Milk, "Mascarpone": Milk, "Ricotta": Milk, "Zabaglione": Egg,
  "Coffee": Coffee, "Espresso": Coffee, "Cappuccino": Coffee,
  "White Chocolate": Candy, "Milk Chocolate": Candy, "Dark Chocolate 50%": Candy,
  "Dark Chocolate 65%": Candy, "Dark Chocolate 75%": Candy, "Dark Chocolate 80%": Candy,
  "Gianduja": Candy, "Nutella-style Hazelnut Cocoa": Candy, "Dulce de Leche": Droplet,
  "Caramel": Droplet, "Salted Caramel": Droplet, "Peanut Butter": Nut,
  "Coconut Cream": Nut, "Cinnamon": Wheat, "Tiramisu": Coffee, "Cheesecake": IceCream2,
  "Honey": Droplet, "Maple": Leaf, "Matcha": Leaf, "Cookies & Cream": Cookie,
  "Stracciatella": IceCream, "Panettone": Wheat, "Cannoli Cream": IceCream2,
  "Crème Brûlée": Flame,
  // Crunchy
  "Oreo": Cookie, "Lotus Biscoff": Cookie, "Ladyfingers": Cookie,
  "Hazelnuts": Nut, "Pistachios": Nut, "Peanuts": Nut, "Almonds": Nut,
  "Puffed Rice": Sprout, "Chocolate Crumble": Cookie, "Cookie Crumble": Cookie,
  // Alcohol
  "Rum": Wine, "Whisky": GlassWater, "Cognac": Wine,
  "Prosecco": Martini, "Tequila": GlassWater,
  // Functional
  "energizing": Zap, "collagen": Sparkles, "anti-aging": Sun,
  "anti-stress": Moon, "relaxing": Flower2,
};

export const getIcon = (name) => iconMap[name] || Sparkles;
